export default "__VITE_ASSET__CbbIGgAu__"